export default "/assets/images/cc-balloon-lg.c7873b8de8b82784.png";